/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const DEFAULT_LOCALE = 'fr';
export const LANGUAGES = [
  { id: 'fr', label: 'Français', alias: ['fr-FR', 'fr', 'fr-CH'] },
  { id: 'en', label: 'English', alias: ['en', 'en-US', 'en-GB'] },
];
export const EXPONENT_TYPES = ['company', 'school', 'cfa'];
